import { useQuery } from "@tanstack/react-query";
import { WORKSHOP } from "@/config/workshop";
import { getWorkshop } from "@/lib/api/workshop";

export function Summary() {
  const { data } = useQuery({
    queryKey: ["workshop", WORKSHOP.slug],
    queryFn: () => getWorkshop(WORKSHOP.slug),
  });

  const amount = data?.active_price?.amount ?? WORKSHOP.pricing.early.amount;
  const regular = data?.regular_price ?? WORKSHOP.pricing.regular.amount;

  return (
    <div className="summary" data-testid="booking-summary">
      <div className="summary-info">
        <h3>{WORKSHOP.title}</h3>
        <p>{`${WORKSHOP.dateLong} · ${WORKSHOP.time}`}</p>
        <p>{WORKSHOP.locationShort}</p>
      </div>
      <div className="summary-price">
        <p className="amount" data-testid="summary-price">
          {amount} €
        </p>
        <p className="meta">Frühbucher</p>
        <p className="meta">danach {regular} €</p>
      </div>
    </div>
  );
}
